export var PromotionValidationReasonEnum;
(function (PromotionValidationReasonEnum) {
    PromotionValidationReasonEnum["VALID"] = "VALID";
    PromotionValidationReasonEnum["NOT_AVAILABLE"] = "NOT_AVAILABLE";
    PromotionValidationReasonEnum["INVALID"] = "INVALID";
    PromotionValidationReasonEnum["EXPIRED"] = "EXPIRED";
    PromotionValidationReasonEnum["EXCEEDED_USAGE"] = "EXCEEDED_USAGE";
    PromotionValidationReasonEnum["EXCEEDED_USAGE_PER_CART"] = "EXCEEDED_USAGE_PER_CART";
    PromotionValidationReasonEnum["NOT_APPLICABLE_FOR_USER"] = "NOT_APPLICABLE_FOR_USER";
    PromotionValidationReasonEnum["NOT_ENOUGH_CART_TOTAL"] = "NOT_ENOUGH_CART_TOTAL";
    PromotionValidationReasonEnum["INVALID_PROMOTION_TARGET"] = "INVALID_PROMOTION_TARGET";
    PromotionValidationReasonEnum["ALREADY_APPLIED"] = "ALREADY_APPLIED";
    PromotionValidationReasonEnum["NOT_AVAILABLE_NOW"] = "NOT_AVAILABLE_NOW";
    PromotionValidationReasonEnum["INCOMPATIBLE"] = "INCOMPATIBLE";
    PromotionValidationReasonEnum["DISCOUNT_PRODUCER_MISSING"] = "DISCOUNT_PRODUCER_MISSING";
    PromotionValidationReasonEnum["INVALID_ORDER_COUNT"] = "INVALID_ORDER_COUNT";
})(PromotionValidationReasonEnum || (PromotionValidationReasonEnum = {}));
//# sourceMappingURL=PromotionValidationReasonEnum.js.map